/**
 * Renders one side of an audit field diff as text: `∅` for nothing, scalars
 * as-is, anything else as JSON so an object never shows up as `[object Object]`.
 */
export function formatFieldValue(value: unknown): string {
  if (value === null || value === undefined) return '∅';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    // Circular or otherwise non-serializable; never fall back to `String()`,
    // which would print `[object Object]`.
    return '[unserializable]';
  }
}
